export class DateFormState {
  readonly date: string = "";
  readonly time: string = "";
}